/*!
 * @splidejs/splide-extension-auto-scroll
 * Version  : 0.5.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */

// prettier-ignore
(function(S){typeof define=="function"&&define.amd?define(S):S()})(function(){"use strict";function S(n){n.length=0}function D(n,t,r){return Array.prototype.slice.call(n,t,r)}function _(n){return n.bind.apply(n,[null].concat(D(arguments,1)))}function q(n){return requestAnimationFrame(n)}function C(n,t){return typeof t===n}var z=Array.isArray;_(C,"function"),_(C,"string"),_(C,"undefined");function B(n){return z(n)?n:[n]}function H(n,t){B(n).forEach(t)}var cn=Object.keys;function sn(n,t,r){if(n){var e=cn(n);e=r?e.reverse():e;for(var o=0;o<e.length;o++){var c=e[o];if(c!=="__proto__"&&t(n[c],c)===!1)break}}return n}function dn(n){return D(arguments,1).forEach(function(t){sn(t,function(r,e){n[e]=t[e]})}),n}var ln=Math.min;function vn(){var n=[];function t(u,s,a,d){o(u,s,function(f,v,l){var h="addEventListener"in f,w=h?f.removeEventListener.bind(f,v,a,d):f.removeListener.bind(f,a);h?f.addEventListener(v,a,d):f.addListener(a),n.push([f,v,l,a,w])})}function r(u,s,a){o(u,s,function(d,f,v){n=n.filter(function(l){return l[0]===d&&l[1]===f&&l[2]===v&&(!a||l[3]===a)?(l[4](),!1):!0})})}function e(u,s,a){var d,f=!0;return typeof CustomEvent=="function"?d=new CustomEvent(s,{bubbles:f,detail:a}):(d=document.createEvent("CustomEvent"),d.initCustomEvent(s,f,!1,a)),u.dispatchEvent(d),d}function o(u,s,a){H(u,function(d){d&&H(s,function(f){f.split(" ").forEach(function(v){var l=v.split(".");a(d,l[0],l[1])})})})}function c(){n.forEach(function(u){u[4]()}),S(n)}return{bind:t,unbind:r,dispatch:e,destroy:c}}var K="move",J="moved",En="updated",Q="drag",pn="dragged",U="scroll",W="scrolled",mn="destroy";function hn(n){var t=n?n.event.bus:document.createDocumentFragment(),r=vn();function e(c,u){r.bind(t,B(c).join(" "),function(s){u.apply(u,z(s.detail)?s.detail:[])})}function o(c){r.dispatch(t,c,D(arguments,1))}return n&&n.event.on(mn,r.destroy),dn(r,{bus:t,on:e,off:_(r.unbind,t),emit:o})}function Y(n,t,r,e){var o=Date.now,c,u=0,s,a=!0,d=0;function f(){if(!a){if(u=n?ln((o()-c)/n,1):1,r&&r(u),u>=1&&(t(),c=o(),e&&++d>=e))return l();q(f)}}function v(E){!E&&w(),c=o()-(E?u*n:0),a=!1,q(f)}function l(){a=!0}function h(){c=o(),u=0,r&&r(u)}function w(){s&&cancelAnimationFrame(s),u=0,s=0,a=!0}function M(E){n=E}function N(){return a}return{start:v,rewind:h,pause:l,cancel:w,set:M,isPaused:N}}function An(n,t){var r;function e(){r||(r=Y(t||0,function(){n(),r=null},null,1),r.start())}return e}var gn="is-active",wn="slide",yn="fade";function X(n,t,r){return Array.prototype.slice.call(n,t,r)}function V(n){return n.bind.apply(n,[null].concat(X(arguments,1)))}function L(n,t){return typeof t===n}function $(n){return!Z(n)&&L("object",n)}var bn=Array.isArray;V(L,"function"),V(L,"string");var Sn=V(L,"undefined");function Z(n){return n===null}function _n(n){return bn(n)?n:[n]}function O(n,t){_n(n).forEach(t)}function Ln(n,t,r){n&&O(t,function(e){e&&n.classList[r?"add":"remove"](e)})}var On=Object.keys;function j(n,t,r){if(n){var e=On(n);e=r?e.reverse():e;for(var o=0;o<e.length;o++){var c=e[o];if(c!=="__proto__"&&t(n[c],c)===!1)break}}return n}function k(n){return X(arguments,1).forEach(function(t){j(t,function(r,e){n[e]=t[e]})}),n}function Tn(n,t){O(n,function(r){O(t,function(e){r&&r.removeAttribute(e)})})}function nn(n,t,r){$(t)?j(t,function(e,o){nn(n,o,e)}):O(n,function(e){Z(r)||r===""?Tn(e,t):e.setAttribute(t,String(r))})}var tn=Math.min,rn=Math.max,qn=Math.floor,zn=Math.ceil,Bn=Math.abs;function Dn(n,t,r){var e=tn(t,r),o=rn(t,r);return tn(rn(e,n),o)}var Cn={speed:1,autoStart:!0,pauseOnHover:!0,pauseOnFocus:!0},Vn={startScroll:"Start auto scroll",pauseScroll:"Pause auto scroll"};function $n(n,t,r){var e=hn(n),o=e.on,c=e.off,u=e.bind,s=e.unbind,a=t.Move,d=a.translate,f=a.getPosition,v=a.toIndex,l=a.getLimit,h=t.Controller,w=h.setIndex,M=h.getIndex,N=t.Direction.orient,E=t.Elements.toggle,en=t.Live,I=n.root,Mn=An(t.Arrows.update,500),p={},m,A,x,F,P,T;function Nn(){var i=r.autoScroll;p=k({},Cn,$(i)?i:{})}function on(){n.is(yn)||!m&&r.autoScroll!==!1&&(m=Y(0,Pn),In(),Fn())}function un(){m&&(m.cancel(),m=null,T=void 0,c([K,Q,U,J,W]),s(I,"mouseenter mouseleave focusin focusout"),s(E,"click"))}function In(){p.pauseOnHover&&u(I,"mouseenter mouseleave",function(i){x=i.type==="mouseenter",R()}),p.pauseOnFocus&&u(I,"focusin focusout",function(i){F=i.type==="focusin",R()}),p.useToggleButton&&u(E,"click",function(){A?y():b()}),o(En,xn),o([K,Q,U],function(){P=!0,b(!1)}),o([J,pn,W],function(){P=!1,R()})}function xn(){var i=r.autoScroll;i!==!1?(p=k({},p,$(i)?i:{}),on()):un(),m&&!Sn(T)&&d(T)}function Fn(){p.autoStart&&(document.readyState==="complete"?y():u(window,"load",y))}function y(){G()&&(m.start(!0),en.disable(!0),F=x=A=!1,an())}function b(i){i===void 0&&(i=!0),A||(A=i,an(),G()||(m.pause(),en.disable(!1)))}function R(){A||(x||F||P?b(!1):y())}function Pn(){var i=f(),g=Rn(i);i!==g?(d(g),Gn(T=f())):(b(!1),p.rewind&&n.go(p.speed>0?0:t.Controller.getEnd())),Mn()}function Rn(i){var g=p.speed||1;return i+=N(g),n.is(wn)&&(i=Dn(i,l(!1),l(!0))),i}function Gn(i){var g=n.length,fn=(v(i)+g)%g;fn!==M()&&(w(fn),t.Slides.update(),t.Pagination.update(),r.lazyLoad==="nearby"&&t.LazyLoad.check())}function an(){if(E){var i=A?"startScroll":"pauseScroll";Ln(E,gn,!A),nn(E,"aria-label",r.i18n[i]||Vn[i])}}function G(){return!m||m.isPaused()}return{setup:Nn,mount:on,destroy:un,play:y,pause:b,isPaused:G}}typeof window<"u"&&(window.splide=window.splide||{},window.splide.Extensions=window.splide.Extensions||{},window.splide.Extensions.AutoScroll=$n)});

function generateJobHTML(job) {
  return `<li class="px-3 py-3 m-0 d-flex flex-column justify-content-between gap-1">
      <a class="py-1 gap-2 apply-link index__slider d-flex justify-content-start justify-content-lg-between align-items-center" href="${job.hostedUrl}" target="_blank" rel="noopener noreferrer">
        <h4 class="mr-3 text-uppercase text-white mb-0">${job.text}</h4>
        <div class="apply-btn d-flex flex-nowrap gap-1 align-items-center">
          <span class="font-family-gotham text-uppercase d-none d-lg-flex m-0 pt-1">
            Apply
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4m-9-1 9-9m0 0v5m0-5h-5"/>
          </svg>
        </div>
      </a>
      <ul class="d-flex flex-wrap gap-1 p-0 m-0">
        <li class="m-0 pl-2 pr-3 py-2 d-flex align-items-center justify-content-center justify-content-lg-start gap-1 flex-grow-1 flex-lg-grow-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 24 24"><path stroke="rgba(255, 255, 255, 0.6)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 21c3.5-3.6 7-6.824 7-10.8C19 6.224 15.866 3 12 3s-7 3.224-7 7.2 3.5 7.2 7 10.8Z"/><path stroke="rgba(255, 255, 255, 0.6)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/></svg>
          <span>${job.categories.location}</span>
        </li>
        <li class="m-0 pl-2 pr-3 py-2 d-flex align-items-center justify-content-center justify-content-lg-start gap-1 flex-grow-1 flex-lg-grow-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 24 24"><path stroke="rgba(255, 255, 255, 0.6)" stroke-linecap="round" stroke-width="2" d="M12 8v4l3 3"/><circle cx="12" cy="12" r="9" stroke="rgba(255, 255, 255, 0.6)" stroke-width="2"/></svg>
          <span>${job.categories.commitment}</span>
        </li>
        <li class="m-0 pl-2 pr-3 py-2 d-flex align-items-center justify-content-center justify-content-lg-start gap-1 flex-grow-1 flex-lg-grow-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 28 28"><path fill="rgba(255, 255, 255, 0.6)" fill-rule="nonzero" d="M17.254 11a2.25 2.25 0 0 1 2.25 2.25v6.249a5.501 5.501 0 0 1-11.002 0V13.25a2.25 2.25 0 0 1 2.25-2.25h6.502Zm0 1.5h-6.502a.75.75 0 0 0-.75.75v6.249a4.001 4.001 0 1 0 8.002 0V13.25a.75.75 0 0 0-.75-.75ZM4.25 11h4.156a3.244 3.244 0 0 0-.817 1.5H4.25a.75.75 0 0 0-.75.75v5.249a3.001 3.001 0 0 0 4.238 2.735c.133.49.324.956.564 1.392A4.501 4.501 0 0 1 2 18.499V13.25A2.25 2.25 0 0 1 4.25 11Zm19.5 0A2.25 2.25 0 0 1 26 13.25v5.25a4.5 4.5 0 0 1-6.298 4.127l.056-.102c.214-.406.386-.837.511-1.289A3 3 0 0 0 24.5 18.5l.001-5.25a.75.75 0 0 0-.75-.75h-3.333A3.244 3.244 0 0 0 19.6 11h4.151ZM14 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm8.003 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM5.997 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM14 4.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm8.003 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-16.006 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/></svg>
          <span>${job.categories.team}</span>
        </li> 
      </ul>
  </li>`;
}

function makeJobsHTML(data) {
  let eoiIndex = data.findIndex((obj) =>
    obj.text.includes("Expression of Interest"),
  );
  if (eoiIndex !== -1) {
    let [obj] = data.splice(eoiIndex, 1);
    obj.text = "Expression of Interest";
    obj.categories.team = "Expression of Interest";
    data.push(obj);
  }

  const jobsHTML = data
    .map((job) => {
      return generateJobHTML(job);
    })
    .join("");

  const jobsListElement = document.querySelector(".js-jobs");
  if (jobsListElement) {
    jobsListElement.innerHTML = jobsHTML;
  }
}

function mountSplideIfExists(selector, config, useExtensions = false) {
  const el = document.querySelector(selector);
  if (el) {
    const instance = new Splide(el, config);
    if (useExtensions && window.splide && window.splide.Extensions) {
      instance.mount(window.splide.Extensions);
    } else {
      instance.mount();
    }
  }
}

// Global array to store YouTube players on the page
const ytPlayers = [];

document.addEventListener("DOMContentLoaded", function () {
  // --- Job List Fetch ---
  try {
    fetch("https://api.lever.co/v0/postings/quadlock?mode=json", {
      credentials: "omit",
    })
      .then((response) => {
        response.json().then((response) => {
          makeJobsHTML(response);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (err) {
    console.error(err);
  }

  // --- Splide Mounting ---

  mountSplideIfExists(".js-splide-our-story-main", {
    arrows: true,
    perMove: 1,
    speed: 200,
    flickPower: 75,
    pagination: true,
  });

  mountSplideIfExists(".js-splide-values-main", {
    perPage: 3,
    gap: "1rem",
    arrows: true,
    perMove: 1,
    speed: 200,
    flickPower: 75,
    pagination: true,
    breakpoints: {
      1220: {
        perPage: 2,
      },
      670: {
        perPage: 1,
      },
    },
  });

  mountSplideIfExists(".js-splide-life-at-ql-main", {
    arrows: true,
    perMove: 1,
    flickPower: 75,
  });

  mountSplideIfExists(".js-splide-where-we-work-main", {
    focus: "center",
    perPage: 5,
    perMove: 1,
    padding: 10,
    gap: "5px",
    trimSpace: "move",
    type: "loop",
    arrows: true,
    speed: 200,
    flickPower: 75,
    pagination: false,
    breakpoints: {
      1860: {
        focus: "center",
        perPage: 4,
        padding: 45,
      },
      1600: {
        focus: "center",
        perPage: 3,
        padding: 45,
      },
      1395: {
        focus: "center",
        perPage: 2,
        padding: 45,
      },
      640: {
        focus: "center",
        perPage: 1,
        padding: 25,
      },
    },
  });

  mountSplideIfExists(".js-splide-office-perks-main", {
    arrows: false,
    perMove: 1,
    speed: 200,
    flickPower: 75,
    pagination: true,
  });

  mountSplideIfExists(
    ".js-splide-awards-main",
    {
      focus: "center",
      speed: 600,
      padding: 30,
      gap: 70,
      trimSpace: "move",
      type: "loop",
      rewind: true,
      arrows: false,
      pagination: false,
      autoWidth: true,
      autoScroll: {
        speed: 0.3,
      },
      breakpoints: {
        1395: {
          gap: 50,
        },
        640: {
          gap: 30,
        },
      },
    },
    true,
  );

  // --- YouTube Player Embedding ---
  let tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  let firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // Attach click events for all video buttons
  document.querySelectorAll(".js-video-button").forEach(function (button) {
    attachButtonClickListener(button);
  });

  function attachButtonClickListener(button) {
    button.addEventListener(
      "click",
      function () {
        // Get the unique ID for this video from a data attribute (e.g. data-player-id="2")
        const playerId = button.dataset.playerId;

        // Select the corresponding preview element and container using the unique id
        const previewElem = document.querySelector(
          "#careers_player_" + playerId,
        );
        const containerElem = document.querySelector(
          "#careers_player_" + playerId + "_container",
        );
        if (!previewElem || !containerElem) return;
        const parent = button.parentNode;

        // Remove the button and fade out the preview image
        button.remove();
        if (parent.firstElementChild) {
          parent.firstElementChild.style.opacity = "0";
        }
        containerElem.classList.add("js-show-video");

        // Create a new div that will become the YouTube player.
        // Use the same id as the preview so that each video block is unique.
        let playerDiv = document.createElement("div");
        playerDiv.id = "careers_player_" + playerId;
        // Assume the preview element holds the YouTube video id in its data-src attribute
        playerDiv.dataset.src = previewElem.dataset.src;

        // Append the player div into the container and ensure the container is in the document
        containerElem.appendChild(playerDiv);
        parent.appendChild(containerElem);

        const videoId = playerDiv.dataset.src;

        // Create a new YouTube player for this video
        let player = new YT.Player(playerDiv.id, {
          videoId: videoId,
          playerVars: {
            autoplay: 0,
            modestbranding: 1,
            origin: window.location.origin,
            rel: 0,
            playsinline: 1,
            controls: 1,
            loop: 0,
          },
          events: {
            onReady: function (event) {
              event.target.playVideo();
              event.target.unMute();
            },
            onStateChange: function (event) {
              if (event.data === YT.PlayerState.PLAYING) {
                // Pause all other video players
                ytPlayers.forEach((p) => {
                  if (
                    p !== player &&
                    p.getPlayerState() === YT.PlayerState.PLAYING
                  ) {
                    p.pauseVideo();
                  }
                });
              }
              // When video ends, restore the preview and reattach the button
              if (event.data === YT.PlayerState.ENDED) {
                let iframeContainer = playerDiv.parentNode;
                playerDiv.remove();
                if (parent.firstElementChild) {
                  parent.firstElementChild.style.opacity = "1";
                }
                iframeContainer.classList.remove("js-show-video");
                // Append the button back and reattach its event listener
                parent.appendChild(button);
                attachButtonClickListener(button);
                // Remove destroyed players
                ytPlayers.splice(ytPlayers.indexOf(player), 1);
              }
            },
          },
        });

        // Save current video player reference
        ytPlayers.push(player);
      },
      { once: true },
    );
  }
});
